module.exports = __webpack_public_path__ + "img/description_logo.d14d93c4.png";